export const URL_GET_SMS_COUNT_REMAIN = '/v1/gocheckin/sms/site/get-sms-remain';
export const URL_GET_SMS_RELOAD_HISTORY = '/v1/gocheckin/sms/site/history';
export const URL_GET_SMS_COUNT = '/v1/gocheckin/sms/site/sms-remain';